import {
  SHOPPER_AGENT_GUIDELINE_MAX_COUNT,
  ShopperAgentGuidelineTextSchema,
} from "@redotech/redo-shopper-agent-settings-common/guideline-config";
import * as z from "zod";

/** Replaces the whole list, in the merchant's order. */
export const updateShopperAgentGuidelines = {
  name: "updateShopperAgentGuidelines" as const,
  input: z.object({
    guidelines: z
      .array(ShopperAgentGuidelineTextSchema)
      .max(SHOPPER_AGENT_GUIDELINE_MAX_COUNT),
    stageDraft: z.boolean().optional(),
  }),
  output: z.object({
    guidelines: z.array(
      z.object({ merchantText: z.string(), rule: z.string() }),
    ),
  }),
};
